import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { BookingRequest as BookingRequest$1 } from "@perxis-auto/forms/lib/components/BookingRequest";
import clsx from "clsx";
import { withEnabledComponent } from "../../../shared/lib/constructor/withEnabledComponent.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import { selectBooking } from "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import styles from "./BookingRequest.module.scss.js";
const BookingRequest = withEnabledComponent(
  memo(function BookingRequest2({ t, config, className, ...props }) {
    if (!config) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", { className: clsx(styles.bookingRequest, className), ...props, children: /* @__PURE__ */ jsx(BookingRequest$1, { ...config }) });
  }),
  selectBooking
);
export {
  BookingRequest
};
